/* eslint-disable */

import { useEffect, useState } from "react";
import { motion } from "framer-motion";

import RaindropTextParagraph from "../../../ui-components/raindrop-text-paragraph/raindrop-text-paragraph.tsx";

import IconLocked from "../../../ui-components/icon-lock/icon-lock";

import { ordinal } from "../../../logic/logic";
import OrganisationLogo from "../../../ui-components/organisation-logo/organisation-logo";
import RaindropButton, {
  ButtonStyle,
} from "../../../ui-components/raindrop-button/raindrop-button.tsx";

import Spacer from "../../../ui-components/spacer/spacer.js";

import WaterfallIcon from "../../../ui-components/waterfall-icon/waterfall-icon.tsx";
import { useNavigate } from "react-router-dom";

import OrganisationTitle from "../../../ui-components/organisation-title/organisation-title.tsx";
import RaindropCircle from "../../../ui-components/raindrop-circle/raindrop-circle.tsx";
import RaindropPage from "../../../ui-components/raindrop-page/raindrop-page.tsx";
import RaindropCard, {
  RaindropCardStyle,
} from "../../../ui-components/raindrop-card/raindrop-card.tsx";
import RaindropMotionFadeUp from "../../../ui-components/raindrop-motion-fade-up/raindrop-motion-fade-up.tsx";
import RaindropHeading from "../../../ui-components/raindrop-heading/raindrop-heading.tsx";

import PercentageDisplay from "../../../ui-components/percentage-display/percentage-display.tsx";
import RaindropCardWarning from "../../../ui-components/raindrop-card-warning/raindrop-card-warning.tsx";
import WaterfallListElement from "../../../ui-components/waterfall-list-element/waterfall-list-element.tsx";
import OrganisationListElement from "../../../ui-components/organisation-list-element/organisation-list-element.tsx";
import FlexRow from "../../../ui-components/flex-row/flex-row.tsx";
import { SausageStyleColor } from "../../../logic/enums.ts";

const WelcomeElement = () => {
  return (
    <RaindropMotionFadeUp>
      <RaindropCard>
        <div className={"flex flex-col gap-4 rounded-lg text-left "}>
          <RaindropHeading
            title="Raindrop Circle"
            style={ButtonStyle.Secondary}
          />
          <div
            id={"no-organisations-home-text"}
            className="flex flex-col gap-4 text-color-dark-text-secondary"
          >
            <RaindropTextParagraph>
              This is where you will distribute your payment
            </RaindropTextParagraph>
            <RaindropTextParagraph>
              You can change your distributions at any time, but the payment
              will only leave your account once a month
            </RaindropTextParagraph>
            <RaindropTextParagraph>
              Use the{" "}
              <span className="font-bold text-color-raindrop-primary">
                Search Tab
              </span>{" "}
              to begin supporting organisations
            </RaindropTextParagraph>
          </div>
        </div>
      </RaindropCard>
    </RaindropMotionFadeUp>
  );
};

const SupportedEntitiesList = ({
  originalValues,
  setSelected,
  setMinorSelected,
}) => {
  if (originalValues.length === 0) {
    return null;
  }
  return (
    <RaindropMotionFadeUp>
      <RaindropCard additionalClasses="flex flex-col gap-4">
        <RaindropHeading title="supporting" isSecondary={true} />

        <div className="flex flex-col w-full gap-4 ">
          {originalValues
            // .filter((v, i) => !isShrunk || v.selected)
            .map((v, index) => {
              let hoverClass = "";

              // if (v.minorSelected) {
              hoverClass =
                "md:dark:hover:bg-color-dark-background-tertiary md:hover:bg-color-background-tertiary md:hover:bg-opacity-20";
              // }

              return (
                <RaindropMotionFadeUp key={index}>
                  <motion.div
                    className={`${hoverClass} p-1  transition-all rounded-lg w-full`}
                    onHoverStart={() => {
                      setMinorSelected(v.id, true);
                    }}
                    onHoverEnd={() => {
                      setMinorSelected(v.id, false);
                    }}
                  >
                    {v.organisation?.id && (
                      <OrganisationListElement
                        id={v.organisation.id}
                        name={v.organisation.name}
                        presignedUrl={v.organisation.presignedUrlLogo}
                        organisation={v.organisation}
                        doShowGiveButton={false}
                        color={v.color}
                        percentage={v.value}
                        doShowColorIndicator={true}
                      />
                    )}
                    {v.waterfall?.id && (
                      <WaterfallListElement
                        title={v.waterfall.title}
                        urlOrganisation={
                          v.waterfall.organisation.presignedUrlLogo
                        }
                        urlUser={v.waterfall.account.presignedUrl}
                        percentage={v.value}
                        color={v.color}
                        isClickable={true}
                        id={v.waterfall.id}
                      />
                    )}
                  </motion.div>
                </RaindropMotionFadeUp>
              );
            })}
        </div>
      </RaindropCard>
    </RaindropMotionFadeUp>
  );
};

const NoPaymentMethodBanner = () => {
  const navigate = useNavigate();

  return (
    <RaindropCardWarning
      title={"Set up a card"}
      body={
        "When you're ready, set up a card so we can start on some great work"
      }
      primaryLabel="Set up now"
      onPrimaryAction={() => {
        navigate("/raindrop/payment-method-add");
      }}
    />
  );
};

const AnonymousBanner = () => {
  const navigate = useNavigate();

  return (
    <RaindropMotionFadeUp>
      <RaindropCard>
        <div
          onClick={() => {
            navigate("/raindrop/entry");
          }}
          className="flex flex-row gap-4 w-full text-left cursor-pointer"
        >
          <i className="fas fa-heart text-color-raindrop-primary text-2xl" />
          <h1 className="flex gap-2 font-bold items-center mr-auto">
            Click here to login or sign up
          </h1>
        </div>
      </RaindropCard>
    </RaindropMotionFadeUp>
  );
};

const YourContributionDay = ({ contributionDay = -1 }) => {
  if (!contributionDay || contributionDay === -1) {
    return;
  }

  return (
    <RaindropMotionFadeUp>
      <RaindropCard additionalClasses="flex flex-col gap-4">
        <RaindropHeading
          title="Contribution Day"
          style={ButtonStyle.Secondary}
        />
        <RaindropTextParagraph>
          You're contribution day is the{" "}
          <span className="white font-bold">
            {ordinal(contributionDay)} of each month.
          </span>
        </RaindropTextParagraph>
      </RaindropCard>
    </RaindropMotionFadeUp>
  );
};

const TakeTheTourPanel = () => {
  return (
    <RaindropMotionFadeUp>
      <div className="w-full ">
        <RaindropCard style={RaindropCardStyle.GradientPink}>
          <div className="flex flex-col gap-4 w-full text-left ">
            <h4 className="font-black text-color-dark-text-primary text-2xl">
              So, how does this work?
            </h4>
            <h6 className="font-bold text-color-dark-text-primary opacity-70">
              Take the tour to learn how to use Raindrop
            </h6>
            <div className="flex w-full items-end justify-end">
              <RaindropButton
                title="Begin Tour"
                to="/raindrop/tour"
                style={ButtonStyle.Secondary}
              />
            </div>
          </div>
        </RaindropCard>
      </div>
    </RaindropMotionFadeUp>
  );
};

const RaindropContribution = ({ sausageValues, setValues, userCurrent }) => {
  const [badgeIndex, setBadgeIndex] = useState(0);

  const isRaindropPlus = userCurrent?.account?.isRaindropPlus;

  const isEditing = false;

  const size = "SMALL";

  const isAnonymous = userCurrent === null;

  let shareableComponents = [];

  const isShrunk = sausageValues.some((v) => v.selected === true);

  const doShowPaymentMethodBanner =
    !userCurrent?.account.paymentMethodActive &&
    !isShrunk &&
    sausageValues.length > 0 &&
    !isAnonymous;

  const setSelected = (sausageId, value) => {
    if (!value) {
      return;
    }
    if (sausageId === "NO_VALUE") {
      // TODO: This is a hack
      return;
    }
    const newCombinedValues = [...sausageValues];
    const index = newCombinedValues.findIndex((v) => v.id === sausageId);
    newCombinedValues.forEach((v) => (v.selected = false));
    newCombinedValues[index].selected = value;
    setValues(newCombinedValues);
  };

  const setMinorSelected = (sausageId, value) => {
    // Minor selected is the state of the element when it is hovered over

    if (!value) {
      return;
    }
    let newCombinedValues = [...sausageValues];
    const index = newCombinedValues.findIndex((v) => v.id === sausageId);
    newCombinedValues.forEach((v) => (v.minorSelected = false));
    newCombinedValues[index].minorSelected = value;
    setValues(newCombinedValues);
  };

  useEffect(() => {
    const newValues = [...sausageValues];
    newValues.forEach((v) => (v.selected = false));
    setValues(newValues);
  }, []);

  return (
    <RaindropPage>
      <div className={"flex xl:hidden flex-col w-full items-center "}>
        <RaindropCircle
          sausageValues={sausageValues}
          setSelected={setSelected}
          setMinorSelected={setMinorSelected}
          size={size}
          badgeIndex={badgeIndex}
          isRaindropPlus={isRaindropPlus}
          isSpringyTransition={false}
          isPaused={userCurrent?.account?.accountPlan?.isPaused}
          accountAwardFeaturedSlug={
            userCurrent?.account?.accountAwardFeatured?.award?.slug
          }
        />
      </div>

      <div className="flex flex-col gap-2 w-full">
        {isAnonymous && <AnonymousBanner />}
        {doShowPaymentMethodBanner && <NoPaymentMethodBanner />}
      </div>
      {sausageValues.length === 0 && <WelcomeElement />}
      <SupportedEntitiesList
        originalValues={sausageValues}
        setSelected={setSelected}
        setMinorSelected={setMinorSelected}
      />
      <YourContributionDay
        contributionDay={userCurrent?.account?.accountPlan?.contributionDay}
      />
      <TakeTheTourPanel />
    </RaindropPage>
  );
};

export default RaindropContribution;
